/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
/* eslint-enable no-console */

// import Swiper JS
import Swiper from "swiper/bundle";
// import Swiper styles
const swiperSpeed = parseInt(
	document.querySelector(".ldx-hero-slider").dataset.speed,
);
const swiperSlideSpeed = parseInt(
	document.querySelector(".ldx-hero-slider").dataset.slidespeed,
);
const swiperLoop =
	document.querySelector(".ldx-hero-slider").dataset.loop === "true"
		? true
		: false;
const swiper = new Swiper(".ldx-hero-slider", {
	autoplay: {
		delay: swiperSpeed,
	},
	speed: swiperSlideSpeed,
	loop: swiperLoop,
	spaceBetween: 0,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});
